<!-- このチケット商材のmax_purchaseに達していて購入画面に遷移できないことを示唆するダイアログ -->
<template>
  <ItemDialog ref="inableToBuy" imageType="alert">
    <template v-slot:content-area>
      <h2>{{ $t("Errors.reachedPurchaseLimit.title") }}</h2>
      <p class="text-center">
        {{ $t("Errors.reachedPurchaseLimit.description") }}
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        :label="$t('Errors.reachedPurchaseLimit.buttonLabel')"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogInableToBuy",
  setup() {
    const inableToBuy = ref(null);

    const openDialog = () => {
      inableToBuy.value.open();
    };

    const closeDialog = () => {
      inableToBuy.value.close();
    };

    return {
      inableToBuy,
      openDialog,
      closeDialog,
    };
  },
};
</script>
